import { ChangeDetectionStrategy, Component, HostBinding } from '@angular/core';

@Component({
    selector: 'ms-modal-cover',
    template: '',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalCoverComponent {
    @HostBinding('class') className = 'modal-gestures-cover';
}
